<template>
	<div class="dialog flex flex-direction">
		<div class="navigation flex align-center justify-center">
			<div class="navigation-left flex align-center"><img src="../assets/images/arrow-left.png" alt="" @click="close" style="height: 18px;" /></div>
			<span class="navigation-title">{{ title }}</span>
		</div>
		<div class="dialog-body flex-sub">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		title: String
	},
	data() {
		return {

		};
	},
	methods: {
		close() {
			this.$emit('close')
		}
	}
};
</script>

<style lang="scss" scoped>
.dialog {
	position: fixed;
	z-index: 100;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #15454f;
	font-size: 0.28rem;
	color: #d2d2d2;
	line-height: 0.4rem;
	&::after {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		content: '';
		height: 2rem;
		background-image: linear-gradient(to top, rgba(#000, 0.6), rgba($color: #000000, $alpha: 0));
	}
	.navigation {
		position: relative;
		height: 1rem;
		box-shadow: 0 0 4px 0 #000000;
		.navigation-left {
			position: absolute;
			top: 0;
			left: 15px;
			bottom: 0;
			width: 100px;
		}
		.navigation-right {
			osition: absolute;
			top: 0;
			right: 15px;
			bottom: 0;
			width: 100px;
		}
		.navigation-title {
			font-size: 18.5px;
			text-align: center;
			color: #fff;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
			padding: 0 1rem;
		}
	}
	.dialog-body {
		padding: 0.2rem 0.3rem;
		overflow: hidden auto;
		// > :last-child {
		// 	margin-bottom: 1rem;
		// }
		.dialog-image {
			img {
				max-width: 100%;
			}
		}
		.dialog-content {
			padding: 0.2rem 0.3rem;
			font-size: 0.28rem;
			color: #fff;
			line-height: 0.4rem;
		}
		
	}
	
}
</style>
